import { Mtds } from 'prove-common'
import { SegmentedProgress, type ProgressSegment } from './SegmentedProgress'

type DelegationSummaryCardProps = {
  /** Navnet på tilsynsdivisjonen fordelingen hører til, om den er kjent. */
  rootLabel?: string
  samplesDelegated: number
  samplesToDelegate: number
  /** Ett felt per enhet rett under roten, slik at oppdelingen er den samme
   *  uansett hvilket nivå brukeren står på. */
  segments: ProgressSegment[]
}

/**
 * Oppsummering av hele fordelingen, vist over brødsmulene slik at brukeren ser
 * status for hele oppgaven uansett hvor langt ned i organisasjonen hen har
 * navigert.
 */
export const DelegationSummaryCard = ({
  rootLabel,
  samplesDelegated,
  samplesToDelegate,
  segments
}: Readonly<DelegationSummaryCardProps>) => {
  const isOverAllocated = samplesDelegated > samplesToDelegate
  const percentage =
    samplesToDelegate > 0
      ? Math.round((samplesDelegated / samplesToDelegate) * 100)
      : 0
  const summary = `${samplesDelegated} av ${samplesToDelegate} prøver fordelt`

  return (
    <Mtds.Group as={Mtds.Grid} data-gap={2}>
      <Mtds.Flex data-justify='space-between' data-align='center' data-gap={3}>
        {rootLabel != null && (
          <Mtds.Muted>Tilsynsdivisjon {rootLabel.toLowerCase()}</Mtds.Muted>
        )}
      </Mtds.Flex>
      <Mtds.Flex
        data-justify='space-between'
        data-align='center'
        data-gap={3}
        className={isOverAllocated ? 'text-danger-text-default' : undefined}
      >
        <strong>{summary}</strong>
        <span>{percentage}%</span>
      </Mtds.Flex>
      <SegmentedProgress
        max={samplesToDelegate}
        label={summary}
        segments={segments}
        isOverAllocated={isOverAllocated}
      />
    </Mtds.Group>
  )
}
